var map = {
	"./AboutAwards.vue": 24882,
	"./AboutPublications.vue": 57045,
	"./BaseButton.vue": 68723,
	"./BaseInputSearch.vue": 19785,
	"./BaseInputSearchPage.vue": 11366,
	"./Button.vue": 79891,
	"./Checkbox.vue": 61133,
	"./Flash.vue": 43538,
	"./FormContact.vue": 35688,
	"./FormNewsletter.vue": 97403,
	"./IconCheckCircle.vue": 31198,
	"./IconExclamationCircle.vue": 97051,
	"./IconInformationCircle.vue": 87237,
	"./IconX.vue": 79863,
	"./IconXCircle.vue": 90260,
	"./Input.vue": 51159,
	"./InputError.vue": 30501,
	"./Label.vue": 48087,
	"./ModalVideo.vue": 43508,
	"./ModalYoutubeVideo.vue": 10858,
	"./SearchInput.vue": 27923,
	"./TheCookieBanner.vue": 27034,
	"./TheFooter.vue": 27467,
	"./TheFooterContact.vue": 27770,
	"./TheHeader.vue": 51645,
	"./TheIntroVideo.vue": 58278,
	"./TheLoader.vue": 94212,
	"./TheMenu.vue": 95128,
	"./TheModalContactForm.vue": 32622,
	"./TheSafeEmail.vue": 633,
	"./TheSearchIndex.vue": 93072,
	"./ValidationErrors.vue": 3273,
	"./bg-video/backgroundVideo.vue": 75529,
	"./bg-video/htmlVideo.vue": 20776,
	"./home-bard/card.vue": 59765,
	"./home-bard/home_full_width.vue": 73719,
	"./home-bard/home_intro.vue": 82633,
	"./home-bard/home_one_column.vue": 56509,
	"./home-bard/home_three_columns.vue": 12094,
	"./home-bard/home_two_columns.vue": 30160,
	"./home-bard/home_two_columns_stretch.vue": 85456,
	"./icons/IconBack.vue": 75107,
	"./icons/IconClose.vue": 79544,
	"./icons/IconDownload.vue": 93491,
	"./icons/IconFormArrow.vue": 52307,
	"./icons/IconLink.vue": 26185,
	"./icons/IconLocation.vue": 70470,
	"./icons/IconPlay.vue": 62068,
	"./icons/IconSearch.vue": 26627,
	"./icons/IconUser.vue": 76996,
	"./icons/LogoBinalogueLoader.vue": 50856,
	"./icons/LogoBinalogueWhite.vue": 27326,
	"./icons/LogoBinalogueWhiteAvatar.vue": 96700,
	"./icons/TextContact.vue": 80831,
	"./icons/TextFooter.vue": 88359,
	"./icons/TextHola.vue": 95217,
	"./icons/TextHolaIntro.vue": 49829,
	"./icons/TextHolaIntroResponsive.vue": 79238,
	"./icons/TextIntro.vue": 54946,
	"./icons/TextIntroMobile.vue": 80094,
	"./icons/TextJoinTeam.vue": 23221,
	"./icons/TextMail.vue": 61559,
	"./icons/TextNext.vue": 54054,
	"./icons/TextPlay.vue": 45673,
	"./icons/TextPrev.vue": 12078,
	"./icons/TextPrivacy.vue": 87904,
	"./icons/TextSearch.vue": 26755,
	"./icons/TextWeAre.vue": 48396,
	"./icons/TextWeAreBinalogue.vue": 61482,
	"./icons/TextWeAreBinalogueResponsive.vue": 17736,
	"./icons/TextWeAreResponsive.vue": 73705,
	"./project-bard/custom_6grid_pop_up.vue": 34691,
	"./project-bard/htmlAudio.vue": 39097,
	"./project-bard/news_metadata.vue": 69871,
	"./project-bard/project_anchor_tag.vue": 62290,
	"./project-bard/project_downloads.vue": 51612,
	"./project-bard/project_gallery.vue": 83050,
	"./project-bard/project_interview_question.vue": 17731,
	"./project-bard/project_interview_title.vue": 6202,
	"./project-bard/project_metadata.vue": 39949,
	"./project-bard/project_one_column.vue": 39636,
	"./project-bard/project_section_footer.vue": 14657,
	"./project-bard/project_section_title.vue": 20750,
	"./project-bard/project_section_title_line_break.vue": 69107,
	"./project-bard/project_slider.vue": 94442,
	"./project-bard/project_three_columns.vue": 77874,
	"./project-bard/project_two_columns.vue": 84586,
	"./project-bard/project_video_bg_image.vue": 4088,
	"./project-bard/project_youtube_video.vue": 96724,
	"./project-bard/spotify_podcast.vue": 73876,
	"./project-bard/vertical_space.vue": 92167,
	"./project-bard/video_pop_up.vue": 62302,
	"./project-bard/youtube_pop_up.vue": 96781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14950;